import { usePictureSets } from "./usePictureSets";
import { usePriceList } from "../providers/PriceListProvider";
import { useMemo } from "react";
import { canPictureSetBeBought } from "@/react/Webshop/utils/digitalPictureUtils";
import { useTranslation } from "react-i18next";
const usePictureSetsAvailableToBuyDigitally = () => {
    const { pictureSets } = usePictureSets();
    const priceList = usePriceList();
    const [t] = useTranslation();
    return useMemo(() => {
        var _a;
        return ((_a = pictureSets === null || pictureSets === void 0 ? void 0 : pictureSets.filter((pictureSet) => {
            return canPictureSetBeBought(pictureSet, priceList, t);
        })) !== null && _a !== void 0 ? _a : []);
    }, [pictureSets, priceList, t]);
};
export default usePictureSetsAvailableToBuyDigitally;
